var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBasketIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.733398 1H3.55352C4.02916 1 4.43898 1.33502 4.53355 1.80116L5.36875 5.91765M5.36875 5.91765L7.32641 15.5665C7.42098 16.0326 7.8308 16.3676 8.30644 16.3676H18.1008C18.5778 16.3676 18.9885 16.0306 19.0815 15.5627L20.7623 7.11274C20.8854 6.49423 20.4122 5.91765 19.7816 5.91765H5.36875Z",
    stroke: "#456D64",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7174 21.183L15.6521 21.1058C15.4397 20.8545 15.4397 20.4867 15.6521 20.2354C16.0033 19.82 16.6437 19.82 16.9949 20.2354C17.2073 20.4867 17.2073 20.8545 16.9949 21.1058L16.9296 21.183C16.6126 21.5581 16.0344 21.5581 15.7174 21.183Z",
    stroke: "#456D64",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.48103 21.183L9.41573 21.1058C9.20334 20.8545 9.20334 20.4867 9.41573 20.2354C9.76695 19.82 10.4074 19.82 10.7586 20.2354C10.971 20.4867 10.971 20.8545 10.7586 21.1058L10.6933 21.183C10.3762 21.5581 9.7981 21.5581 9.48103 21.183Z",
    stroke: "#456D64",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBasketIcon);
export default __webpack_public_path__ + "static/media/basket_icon.26f701c032074e0427dde3432d7aebc5.svg";
export { ForwardRef as ReactComponent };